

















import Vue, { PropType } from 'vue';
// import * as api from '@/api';
// eslint-disable-next-line import/no-extraneous-dependencies
import { startsWith } from 'lodash';
import { TaskUserCommitsItem } from '@/api';

export enum Tool {
  rectangle = 'icon-zzj-juxing',
  circle = 'icon-zzj-yuanxingweixuanzhong',
  pen = 'icon-zzj-huabi',
  text = 'icon-zzj-wenzi1',
  undo = 'icon-zzj-chexiao1'
}
export default Vue.extend({
  components: { },
  props: {
    visible: { type: Boolean },
    name: { type: String },
    base64PImg: { type: String },
    commit: { type: Object as PropType<TaskUserCommitsItem> },
    onlyShow: { type: Boolean },
  },
  data() {
    return {
      tools: Object.keys(Tool)
        .filter((v) => !startsWith(v, 'icon'))
        .map((key) => Tool[key]),
      selectedTool: '',
      colors: [
        'rgb(239, 67, 67)',
        'rgb(239, 124, 67)',
        'rgb(238, 233, 83)',
        'rgb(67, 238, 106)',
        'rgb(65, 239, 210)',
        'rgb(67, 160, 240)',
        'rgb(165, 67, 240)',
      ],
      selectedColor: 'rgb(239, 67, 67)',
      currentIndex: -1,
    };
  },
  methods: {

  },
});
